import api from "./api";
import endpoints from "./endpoints";

export default {
  get: async function () {
    const response = await api.get(endpoints.configurationManager.emailSettings.get);
    return response.data;
  },

  save: async function (args: any) {
    const response = await api.post(endpoints.configurationManager.emailSettings.update, args);
    return response.data;
  },
  checkOAuthAuthentication: async function () {
    const response = await api.get(endpoints.configurationManager.emailSettings.oAuth.check);
    return response.data;
  },
  deleteOAuthAuthentication: async function () {
    const response = await api.post(endpoints.configurationManager.emailSettings.oAuth.delete);
    return response.data;
  },
  startOAuthAuthentication: async function () {
    const response = await api.post(endpoints.configurationManager.emailSettings.oAuth.start);
    return response.data;
  },
  checkOAuthAuthenticateResult: async function (userCode: string) {
    const response = await api.get(endpoints.configurationManager.emailSettings.oAuth.checkResult, { params: { userCode } });
    return response.data;
  }
};
